
import theme from 'Theme';
import Icon from 'UI/Icon.vue';

export default {
    components: { Icon },
    props: {
        placementIcon: {
            type: String,
            required: true,
        },
        placementName: {
            type: String,
            required: true,
        },
        placementType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            theme,
        };
    },
};
